import { Bars3Icon } from '@heroicons/react/24/outline';
import * as RadixSlider from '@radix-ui/react-slider';
import { cs } from '@bbkAdminUtils/css-utils';

type SliderProps = {
  ariaLabel?: string;
  min: number;
  max: number;
  step: number;
  value: number;
  defaultValue?: number;
  onValueChange?: (value: number) => void;
};

export default function Slider({
  ariaLabel,
  min,
  max,
  step,
  value,
  defaultValue,
  onValueChange,
}: Readonly<SliderProps>) {
  return (
    <RadixSlider.Root
      className="tw-relative tw-flex tw-h-5 tw-w-4/5 tw-touch-none tw-select-none tw-items-center"
      value={[value]}
      defaultValue={[defaultValue ?? min]}
      max={max}
      step={step}
      min={min}
      onValueChange={(valueArr) => {
        onValueChange?.(valueArr[0] as any);
      }}
    >
      <RadixSlider.Track className="tw-relative tw-h-1.5 tw-flex-grow tw-rounded-full tw-bg-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_30%,transparent)] @md:tw-h-1">
        <RadixSlider.Range className="tw-absolute tw-h-full tw-rounded-full tw-bg-[var(--pricing-page-text-font-text-color)]" />
      </RadixSlider.Track>
      <RadixSlider.Thumb
        className={cs(
          'tw-block tw-h-7 tw-w-7 tw-cursor-pointer tw-rounded-full tw-border-2 tw-shadow-xl tw-outline-none tw-transition-all',
          'tw-flex tw-items-center tw-justify-center',
          '@md:tw-h-3 @md:tw-w-3 @md:hover:tw-h-4 @md:hover:tw-w-4',
          'tw-border-[var(--pricing-page-text-font-text-color)] tw-bg-[var(--pricing-page-card-background-color)]',
          'hover:tw-h-7 hover:tw-w-7 hover:tw-border-[3px] hover:tw-bg-[var(--pricingtable-style-accent-color)]'
        )}
        aria-label={ariaLabel}
      >
        <Bars3Icon className="tw-h-4 tw-stroke-[var(--pricing-page-text-font-text-color)] tw-opacity-40 @md:tw-hidden" />
      </RadixSlider.Thumb>
    </RadixSlider.Root>
  );
}
